const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBluesignlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bluesign") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    style: {
      fill: "#003274"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,198.2c-4.1,0-7.1,1.8-8.7,4.7h-.1V186.8h-.1l.1-.1H22.8v2.9l4.1.4h0s0,30-.1,31.1h0l-4.1.4v2.9h7.9l.3-4.2H31a9.495,9.495,0,0,0,8.6,4.8c5.7,0,11.5-4.5,11.5-13.7C51.2,203.5,46.7,198.2,40.3,198.2Zm-1.6,23a7.177,7.177,0,0,1-7-5.4,9.852,9.852,0,0,1-.2-1.7v-4.5a6.929,6.929,0,0,1,.3-2,7.452,7.452,0,0,1,7-5.7c5,0,7.7,4.4,7.7,9.5,0,5.8-2.9,9.8-7.8,9.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.1 186.8 63.1 186.8 54.3 186.8 54.3 189.6 58.4 190 58.4 221.1 58.4 221.1 54.3 221.4 54.3 224.3 67.2 224.3 67.2 221.4 63.1 221.1 63.1 186.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.2,198.2c-7.5,0-12,6-12,13.8s4.7,12.9,12.6,12.9a21.2,21.2,0,0,0,8.6-1.6l-.8-3.3a15.743,15.743,0,0,1-7.1,1.3c-4.7,0-8.7-2.6-8.8-8.9h18a14.979,14.979,0,0,0,.2-2.2C123.8,205.5,121.6,198.2,113.2,198.2Zm6.1,10.8H105.7c.4-3.2,2.4-7.5,7.1-7.5C118.1,201.5,119.3,206.1,119.3,209Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.6,209.5c-3.3-1.3-4.8-2.3-4.8-4.4,0-1.9,1.5-3.5,4.2-3.5a9.309,9.309,0,0,1,5.2,1.5l1.1-3.4a12.464,12.464,0,0,0-6.2-1.6c-5.4,0-8.8,3.4-8.8,7.5,0,3.1,2.2,5.6,6.8,7.2,3.4,1.3,4.7,2.4,4.7,4.7,0,2.2-1.6,3.8-4.9,3.8a13.5,13.5,0,0,1-6.2-1.8l-1.1,3.5a15.075,15.075,0,0,0,7.2,1.8c6,0,9.5-3.2,9.5-7.7C145.3,213.4,142.9,211.1,138.6,209.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2,188.6a2.818,2.818,0,0,0-2.9,2.8v.1a2.777,2.777,0,0,0,2.6,2.9h.2a2.818,2.818,0,0,0,2.9-2.8,2.906,2.906,0,0,0-2.8-3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.4,202.6h-.1a8.522,8.522,0,0,0-8-4.4c-5.9,0-11.6,4.9-11.6,13.5,0,7.1,4.5,12.5,10.9,12.5a8.883,8.883,0,0,0,8.1-4.3h.1v2.8c0,6.5-3.5,9-8.3,9a14.416,14.416,0,0,1-7.5-2.1l-1.2,3.6a15.8,15.8,0,0,0,8.5,2.1,14.21,14.21,0,0,0,9.4-3.1c2.4-2.3,3.6-5.8,3.6-11.7V205.6c0-3.1.1-5.2.2-7h-4.1Zm-.6,10.8a7.267,7.267,0,0,1-.4,2.5,6.874,6.874,0,0,1-6.5,4.8c-5,0-7.6-4.2-7.6-9.2,0-5.9,3.2-9.7,7.6-9.7a6.639,6.639,0,0,1,6.5,5,7.613,7.613,0,0,1,.3,2.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.4,209.1c0-8.8-5.5-10.9-9-10.9a9.448,9.448,0,0,0-8.5,4.8h-.1l-.3-4.2h-8.1v2.9l4.1.4c0,1.1.1,2.3.1,3.7v15.4h0l-4.1.4v2.9h12.9v-2.9l-4.1-.4h0V209.1a8.329,8.329,0,0,1,.3-2.2,6.73,6.73,0,0,1,6.2-4.8c4.4,0,5.9,3.4,5.9,7.6v11.5l-4.1.4v2.9h12.8v-2.9l-4.1-.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.8 198.7 148.8 201.6 152.9 202 152.9 224.3 157.6 224.3 157.6 198.7 148.8 198.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7,221.1V198.7H86v2.9l4,.4v12.4a6.722,6.722,0,0,1-.4,2.4,6.864,6.864,0,0,1-6.1,4.3c-4.2,0-5.7-3.3-5.7-8.2V198.8H69v2.9l4.1.4v11.7c0,8.9,4.8,11.2,8.8,11.2a9.448,9.448,0,0,0,8.5-4.8h.1l.3,4.2H98v-2.9l-3.3-.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.6,187.4a6.1,6.1,0,0,0,0,12.2,6.061,6.061,0,0,0,6.1-6.1,6.124,6.124,0,0,0-6.1-6.1Zm0,11.2a5,5,0,1,1,5-5h0a5.081,5.081,0,0,1-5,5Zm2.5-6.4c0-1.3-.9-1.9-2.4-1.9h-2.3v6.5h1.1v-2.5h1.1l1.5,2.6h1.2l-1.5-2.7a1.956,1.956,0,0,0,1.3-2Zm-3.6,1v-2h1.2c.9,0,1.4.2,1.4,1s-.5,1-1.4,1Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluesignlogo);
export default __webpack_public_path__ + "static/media/bluesignlogo.65d6bf76d99d0c1722e7b308d9b82a59.svg";
export { ForwardRef as ReactComponent };